import { QueryClient } from '@tanstack/vue-query'

import { getQueryTime } from './utils/unit-converter'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: getQueryTime(3, 'min'),
    },
  },
})

export { queryClient }
